import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Paginate from 'vuejs-paginate'
import ToggleButton from 'vue-js-toggle-button'
import vSelect from 'vue-select'
import VueCookies from 'vue-cookies'
import VueClipboard from 'vue-clipboard2'
import OneSignalVue from 'onesignal-vue'

import vuetify from '@/plugins/vuetify'
import 'vuetify/dist/vuetify.min.css'

import 'vue-select/dist/vue-select.css'
import './helpers/validation'

Vue.use(vuetify)

Vue.component('paginate', Paginate)
Vue.component("v-select", vSelect)
Vue.use(ToggleButton)
Vue.use(VueClipboard)
Vue.use(VueCookies)
Vue.use(OneSignalVue)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App),
  beforeMount () {
    this.$OneSignal.init({ appId: process.env.APP_ID_ONESIGNAL})
  }
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js